import { SvgIcon, SvgIconProps } from "@mui/material";

export const FlagFilled2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M6 3h14l-2 4.5 2 4.5H6"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M6 3h14l-2 4.5 2 4.5H6"
      />
      <path
        stroke="currentColor"
        stroke-linecap="square"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M6 19.5V3"
      />
    </svg>
  </SvgIcon>
);
